import { Node, mergeAttributes } from '@tiptap/core';

/**
 * Minimal inline atom node to carry an exclusive avatar deviation payload.
 *
 * - Name must be 'da-exclusive-avatar' to match our JSON content and extractors
 * - Renders as an invisible span inside the editor
 * - Stores the deviation as a JSON string in a data attribute for DOM roundtrips
 */
export const DaExclusiveAvatar = Node.create({
  name: 'da-exclusive-avatar',
  group: 'inline',
  inline: true,
  atom: true,
  selectable: false,
  draggable: false,

  addAttributes() {
    return {
      deviation: {
        default: null,
        parseHTML: element => {
          const raw = element.getAttribute('data-deviation');
          if (!raw) return null;
          try {
            return JSON.parse(raw);
          } catch (e) {
            return null;
          }
        },
        renderHTML: attrs => {
          return attrs?.deviation
            ? { 'data-deviation': JSON.stringify(attrs.deviation) }
            : {};
        },
      },
    } as const;
  },

  parseHTML() {
    return [
      // Our own marker
      { tag: 'span[data-da-exclusive-avatar]' },
      // Fallback marker that carries the JSON payload
      { tag: 'span[data-deviation]' },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return [
      'span',
      mergeAttributes(HTMLAttributes, {
        'data-da-exclusive-avatar': '1',
        style: 'display:none',
      }),
    ];
  },
});
